/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import type { Position } from 'uikit';
import { Tooltip, IconInfo } from 'uikit';
import { getElementCoordinatesBySelector } from 'utils/dom';

import type React from 'react';
import { useCallback, useState } from 'react';

import type { ITableLikeTreeItemNotificationItem } from '../context';

import Style from './HierarchyItemInformer.module.css';

interface IHierarchyItemInformer {
    treeItemId: number;
    informer: ITableLikeTreeItemNotificationItem;
    onInformerClose?: (treeItemId: number) => any;
}

export const HierarchyItemInformer: React.FC<IHierarchyItemInformer> = (props) => {
    const { informer, onInformerClose, treeItemId } = props;
    const { message, icon } = informer;

    const [position, setPosition] = useState<Position>(undefined);

    const onMouseEnter = useCallback((event: React.MouseEvent) => {
        setPosition(getElementCoordinatesBySelector(event.target, '', true));
    }, []);

    const onMouseLeave = useCallback(() => {
        setPosition(undefined);
    }, []);

    const onClick = useCallback(() => {
        onInformerClose?.(treeItemId);
    }, [onInformerClose, treeItemId]);

    return (
        <div
            className={Style.hierarchyItemInformer}
            onMouseEnter={message ? onMouseEnter : undefined}
            onMouseLeave={message ? onMouseLeave : undefined}
            onClick={onClick}
        >
            {icon || <IconInfo size="xs" className="default-icon" />}
            {message && <Tooltip position={position}>{message}</Tooltip>}
        </div>
    );
};

HierarchyItemInformer.displayName = 'HierarchyItemInformer';
